import { render, staticRenderFns } from "./Legislation.vue?vue&type=template&id=1ad97192&scoped=true&"
import script from "./Legislation.vue?vue&type=script&lang=js&"
export * from "./Legislation.vue?vue&type=script&lang=js&"
import style0 from "./Legislation.vue?vue&type=style&index=0&id=1ad97192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad97192",
  null
  
)

export default component.exports